import React, { useEffect, useState } from "react";
import { Button } from "antd";
import TierCards from "./TierCards";

interface Props {
  value: string[];
  onCancel: () => void;
  onApply: (value: string[]) => void;
}

export default function TierDropdown({ value, onCancel, onApply }: Props) {
  const [draft, setDraft] = useState<string[]>(value);

  useEffect(() => setDraft(value), [value]);

  return (
    <div className="v2-brand-dropdown v2-tier-dropdown">
      <h3 className="v2-filters__title">Tour Standard</h3>

      <TierCards
        selected={draft}
        onToggle={(tier) =>
          setDraft(draft.includes(tier) ? draft.filter((item) => item !== tier) : [...draft, tier])
        }
      />

      <div className="v2-brand-dropdown__footer">
        <Button type="text" className="v2-filters__clear" onClick={() => setDraft([])}>
          Clear
        </Button>
        <Button className="v2-brand-dropdown__cancel" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="primary" className="v2-filters__apply" onClick={() => onApply(draft)}>
          Apply
        </Button>
      </div>
    </div>
  );
}
